import React, { useState, useEffect } from 'react';
import { Modal, Input } from 'antd';
const { TextArea } = Input;

export default function ModalMessage({ visible, onOk, onCancel, modalRecord }) {
  const [message, setMessage] = useState(modalRecord?.message);
  useEffect(() => {
    setMessage(modalRecord?.message);
  }, [modalRecord]);
  return (
    <Modal
      title="Modifier le message"
      centered
      okText="Enregistrer"
      cancelText="Annuler"
      visible={visible}
      onOk={() => {
        if (message !== modalRecord?.message) {
          let newModalRecord = { ...modalRecord };
          newModalRecord.manualmessage = true;
          newModalRecord.message = message;
          onOk(newModalRecord);
        } else {
          onCancel();
        }
      }}
      onCancel={() => onCancel()}>
      <TextArea
        value={message}
        rows={10}
        showCount
        maxLength={1600}
        onChange={(e) => {
          setMessage(e.currentTarget.value);
        }}
      />
    </Modal>
  );
}
